// Module
var code = "<sign-in-form *ngIf=\"!errorInfo\" [action]=\"action\"></sign-in-form> <sign-in-error *ngIf=\"errorInfo\" [info]=\"errorInfo\" (onActionClick)=\"errorActionClicked($event)\"></sign-in-error>";
// Exports
module.exports = code;